import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import {store} from './Redux/Store';


const app = document.getElementById('app');

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    app);
serviceWorker.unregister();


console.log("%cKSU %cETC",
		"font-size: 13px; background-color: #0084bd; color: #fff; padding: 5px; border-top-left-radius: 8px; border-bottom-left-radius: 8px;",
		"font-size: 13px; background-color: #3e3e3e; color: #fff; padding: 5px; border-top-right-radius: 8px; border-bottom-right-radius: 8px;")